import { Controller } from "@hotwired/stimulus"
import { cookieHelper } from "../helpers/cookie_helper"

export default class extends Controller {
  static targets = ["menu", "button", "label"]
  static classes = ["dark"]
  static values = {
    cookieName: String,
    labelTemplate: String
  }

  initialize() {
    this.colorSchemeMedia = window.matchMedia("(prefers-color-scheme: dark)")
    this.systemThemeChangeHandler = (event) => {
      if (cookieHelper.getCookie(this.cookieNameValue) == "system") {
        let chosenTheme = event.matches ? "dark" : "light"
        this.switch(chosenTheme, true)
      }
    }
  }

  connect() {
    this.colorSchemeMedia.addEventListener("change", this.systemThemeChangeHandler)
    const storedTheme = cookieHelper.getCookie(this.cookieNameValue) || "system"
    this.updateButton(storedTheme)
  }

  disconnect() {
    this.colorSchemeMedia.removeEventListener("change", this.systemThemeChangeHandler)
  }

  change(event) {
    const chosenTheme = event.target.dataset.themeValue
    this.switch(chosenTheme)
  }

  switch(chosenTheme, autodetected) {
    const htmlElement = document.querySelector("html")
    const isSystemDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches
  
    switch (chosenTheme) {
      case "dark":
        htmlElement.classList.add(this.darkClass)
        break
      case "light":
        htmlElement.classList.remove(this.darkClass)
        break
      case "system":
        htmlElement.classList.toggle(this.darkClass, isSystemDarkMode)
        break
    }
  
    if (!autodetected) {
      cookieHelper.updateCookie(this.cookieNameValue, chosenTheme)
    }

    this.updateButton(chosenTheme)

    this.dispatch("closeDropdown", { detail: this.element })
  }

  updateButton(chosenTheme) {
    const menuOption = this.element.querySelector(`[data-theme-value="${chosenTheme}"]`)
    const iconElement = menuOption?.querySelector(".material-symbols-outlined")
    const iconText = iconElement?.innerText?.trim()
    const labelText = menuOption ? menuOption.textContent.replace(/\s+/g, " ").trim() : ""
    const buttonElement = this.buttonTarget.closest("button")

    if (iconText) {
      this.buttonTarget.innerText = iconText
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = labelText || ""
    }

    if (buttonElement) {
      const template = this.hasLabelTemplateValue ? this.labelTemplateValue : "Change theme, current selection: %{theme}"
      const finalLabel = template.replace("%{theme}", labelText || chosenTheme)
      buttonElement.setAttribute("aria-label", finalLabel)
      if (labelText) {
        buttonElement.setAttribute("title", labelText)
      } else {
        buttonElement.removeAttribute("title")
      }
    }
  }
}
